import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

interface AreaBlackChartProps {
  series: ApexAxisChartSeries;
  height: number;
  color?: string[];
  categories: string[];
}

const AreaBlackChart: React.FC<AreaBlackChartProps> = ({
  series,
  height,
  color,
  categories,
}) => {
  const [options, setOptions] = useState<ApexCharts.ApexOptions>({
    chart: {
      id: "area-chart-orderByDay",
      type: "area",
      height: 350,
      foreColor: "#ccc",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    colors: color || ["#029ddb", "#3e9ba2", "#99d98c"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      width: [2, 2, 2],
    },
    xaxis: {
      type: "datetime",
      axisBorder: {
        show: false,
        color: "#78909C",
        offsetX: 0,
        offsetY: 0,
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#78909C",
        height: 6,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        show: true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        offsetX: 0,
        offsetY: -15,
        datetimeUTC: true,
        datetimeFormatter: {
          year: "yyyy",
          month: "MMM 'yy",
        },
      },
    },
    yaxis: {
      show: true,
      min: 0,
      max: 100,
      labels: {
        show: true,
        offsetX: -10,
      },
      floating: false,
      decimalsInFloat: 0,
    },
    tooltip: {
      theme: "dark",
      x: {
        format: "dd/MM/yy",
      },
    },
    grid: {
      borderColor: "#535A6C",
      padding: {
        right: 0,
        left: 0,
      },
      position: "back",
      row: {
        opacity: 0.2,
      },
      column: {
        opacity: 0.2,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
  });

  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      xaxis: {
        ...prevOptions.xaxis,
        categories: categories,
      },
    }));
  }, [categories]);

  return <Chart options={options} series={series} type="area" height={height} />;
};

export default AreaBlackChart;